import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd443808"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"color":"#333"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "注：若为续租，则地址变更前后的内容填写一致即可", -1))
const _hoisted_3 = { class: "form-content" }
const _hoisted_4 = { class: "footer-container" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("申请审批")

import { message ,Modal} from "ant-design-vue";
import { businessApply ,
  businessDetailApi} from "@/api/businessChange";
import { reactive,ref ,createVNode,onMounted} from "vue";
import { CheckCircleFilled } from '@ant-design/icons-vue';
import HeadTitle from "@/components/HeadTitle.vue";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();
const { id } = route.query;
// 申请事项
const plainOptions = [
  "地址变更",
  "股权变更",
  "名称变更",
  "注册资本变更",
  "营业范围变更",
  "法人、负责人变更",
];
// 表单字段定义
const FormData = reactive({
  check:[],
  CompanyId:0,
  BusinessRegisteredAddress:null,//工商变更地址
  ChangeMatters:[],
});

plainOptions.forEach((item,index)=>{
  let obj ={
    ChangeCode:0,
    ChangeBefore:'',
    ChangeAfter:'',
  }
  obj.ChangeCode = index + 1
  FormData.ChangeMatters.push(obj)
})
//基本字段定义
const data = reactive({
  winHeight:0,//页面最小高度
  loading:false,//按钮loading
})


/**设置页面动态高度 */
const setWinHeight = () => {
  data.winHeight = document.querySelector('.side-box').getBoundingClientRect().height - 42;
}
setWinHeight()
//表单提交
const FormRef = ref();
const handleOk =()=>{
  FormRef.value.validate().then(async()=>{
    data.loading = true
    //提交申请
    var list = []
    FormData.ChangeMatters.forEach(item =>{
      if(FormData.check.includes(item.ChangeCode.toString())){
        list.push(item)
      }
    })
    const { Data, Success, Message } = await businessApply({
      CompanyId: FormData.CompanyId,
      BusinessRegisteredAddress: FormData.BusinessRegisteredAddress,
      ChangeMatters: list,
      id:id,
    });
    
    if (Success) {
      router.push({
        path: "/changeProcess",
        query: {
          id: Data.Id,
          ChangeCompanyId:Data.ChangeCompanyId,
          traceId:Data.TraceId
        },
      });
      
    } else {
      message.warning(Message);
    }
  }).catch((rep:any)=>{
    FormRef.value.scrollToField(rep.errorFields[0].name)
  })
}
//点击返回按钮
const goBack=()=>{
  if(FormData.BusinessRegisteredAddress){
      modelShow()
      return
  }else{
    var result = FormData.ChangeMatters.findIndex(item=>{
      if(item.ChangeBefore || item.ChangeAfter){
        return item
      }
    })
    result>0?modelShow():router.go(-1);
  }
   
  
}
//二次确认弹窗
const modelShow = ()=>{
  Modal.confirm({
      content: "已填写内容不保存,确认要退出申请吗？",
      icon: createVNode(CheckCircleFilled),
      onOk() {
        // router.push('/changelist')
        router.go(-1)
      },
      style: {
        top: "30%",
      },
      cancelText: "取消",
      onCancel() {
        Modal.destroyAll();
      },
    });
}

//获取工商详情
const getDetail = async ()=>{
  const { Data } = await businessDetailApi({
    Id: id,
  });
  if(Data){
    FormData.BusinessRegisteredAddress = Data.PageData.BusinessRegisteredAddress
    Data.PageData.ChangeMatters.forEach(
        (item,index)=> {
          FormData.check.push(item.ChangeCode.toString())
          let idx = FormData.ChangeMatters.findIndex(item1 =>item1.ChangeCode == item.ChangeCode)
          FormData.ChangeMatters[idx] = Data.PageData.ChangeMatters[index]
        }
      );
    }
}

onMounted(()=>{
  if(id){
    getDetail()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BreadCrumb, { meteItems: ['工商变更', '提交申请'] }),
    _createElementVNode("div", {
      class: "centerBox",
      style: _normalizeStyle({ minHeight: _unref(data).winHeight + 'px' })
    }, [
      _createVNode(HeadTitle, { title: "工商变更申请" }),
      _createVNode(_component_a_form, {
        ref_key: "FormRef",
        ref: FormRef,
        model: _unref(FormData),
        labelAlign: "left",
        "label-col": { style: { width: '140px' } },
        colon: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            name: "check",
            label: "申请事项",
            rules: [{ required: true, message: '请勾选申请事项' }],
            class: "blockItem"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_checkbox_group, {
                value: _unref(FormData).check,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(FormData).check) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(plainOptions, (item, index) => {
                    return _createVNode(_component_a_checkbox, {
                      key: index,
                      value: (index + 1).toString(),
                      label: item
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_1, _toDisplayString(plainOptions[index]), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "label"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          (_unref(FormData).check.includes('1'))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_a_form_item, {
                  name: ['ChangeMatters', 0, 'ChangeBefore'],
                  label: "办公地址变更前",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      placeholder: "请填写地址",
                      value: _unref(FormData).ChangeMatters[0].ChangeBefore,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(FormData).ChangeMatters[0].ChangeBefore) = $event)),
                      maxlength: "200",
                      "auto-size": ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: ['ChangeMatters', 0, 'ChangeAfter'],
                  label: "办公地址变更后",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      placeholder: "请填写地址",
                      value: _unref(FormData).ChangeMatters[0].ChangeAfter,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(FormData).ChangeMatters[0].ChangeAfter) = $event)),
                      maxlength: "200",
                      "auto-size": ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "BusinessRegisteredAddress",
                  label: "工商注册地址变更后",
                  required: "",
                  class: "mb8"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      placeholder: "请填写地址",
                      value: _unref(FormData).BusinessRegisteredAddress,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(FormData).BusinessRegisteredAddress) = $event)),
                      maxlength: "200",
                      "auto-size": ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _hoisted_2
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FormData).ChangeMatters, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.ChangeCode,
                class: _normalizeClass(item.ChangeCode==5?``:'itemBox')
              }, [
                (_unref(FormData).check.includes(item.ChangeCode.toString()) && item.ChangeCode !=1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (item.ChangeCode==5)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_a_form_item, {
                              name: ['ChangeMatters', index, 'ChangeBefore'],
                              label: `${plainOptions[index]}前`,
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_textarea, {
                                  placeholder: "请填写",
                                  value: item.ChangeBefore,
                                  "onUpdate:value": ($event: any) => ((item.ChangeBefore) = $event),
                                  maxlength: "500",
                                  "auto-size": ""
                                }, null, 8, ["value", "onUpdate:value"])
                              ]),
                              _: 2
                            }, 1032, ["name", "label"]),
                            _createVNode(_component_a_form_item, {
                              name: ['ChangeMatters', index, 'ChangeAfter'],
                              label: `${plainOptions[index]}后`,
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_textarea, {
                                  placeholder: "请填写",
                                  value: item.ChangeAfter,
                                  "onUpdate:value": ($event: any) => ((item.ChangeAfter) = $event),
                                  maxlength: "500",
                                  "auto-size": ""
                                }, null, 8, ["value", "onUpdate:value"])
                              ]),
                              _: 2
                            }, 1032, ["name", "label"])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_a_form_item, {
                              name: ['ChangeMatters', index, 'ChangeBefore'],
                              label: `${plainOptions[index]}前`,
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  placeholder: "请填写",
                                  value: item.ChangeBefore,
                                  "onUpdate:value": ($event: any) => ((item.ChangeBefore) = $event),
                                  maxlength: "50"
                                }, null, 8, ["value", "onUpdate:value"])
                              ]),
                              _: 2
                            }, 1032, ["name", "label"]),
                            _createVNode(_component_a_form_item, {
                              name: ['ChangeMatters', index, 'ChangeAfter'],
                              label: `${plainOptions[index]}后`,
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  placeholder: "请填写",
                                  value: item.ChangeAfter,
                                  "onUpdate:value": ($event: any) => ((item.ChangeAfter) = $event),
                                  maxlength: "50"
                                }, null, 8, ["value", "onUpdate:value"])
                              ]),
                              _: 2
                            }, 1032, ["name", "label"])
                          ], 64))
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_button, {
              size: "large",
              onClick: goBack
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              size: "large",
              type: "primary",
              onClick: handleOk,
              loading: _unref(data).loading
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ], 4)
  ], 64))
}
}

})